const routes = {
  createUser: 'users/add',
  getUsers: 'users',
  updateUser: 'users/update',
  updateUserStatus: 'users/disable',
  getUserPermissions: 'users/permissions',
};

export default routes